module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "Doug_Martin.75fd0952.png";